import { useCallback, useMemo, useState } from 'react';

// PARA-105 §7 — стек push-экранов поверх текущего таба (без react-router,
// решение §7 Технического дизайна story).
// PARA-128 — добавлены экраны создания и редактирования задачи.
// PARA-131 — экран подписки (push поверх текущего экрана, AC-1).
// PARA-133 — экран справки. articleId — ВНУТРЕННИЙ deep-link на конкретную
// статью (AC-7); внешние ссылки (URL, start_param) невозможны без изменений
// backend и вне scope (F-8, F-9).
// PARA-136 — экран настроек вечернего напоминания.
// PARA-140 — экран истории платежей: логический роут /billing/history
// (react-router в проекте нет, навигация = стек экранов).
export type Screen =
  | { type: 'task-detail'; taskId: number }
  | { type: 'procrastination' }
  | { type: 'create-task' }
  | { type: 'edit-task'; taskId: number }
  | { type: 'billing' }
  | { type: 'billing-history' }
  | { type: 'faq'; articleId?: string }
  | { type: 'evening-reminder-settings' };

export interface ScreenStack {
  current: Screen | null;
  push: (screen: Screen) => void;
  pop: () => void;
}

export function useScreenStack(): ScreenStack {
  const [stack, setStack] = useState<Screen[]>([]);

  const push = useCallback((screen: Screen) => {
    setStack((prev) => [...prev, screen]);
  }, []);

  const pop = useCallback(() => {
    setStack((prev) => prev.slice(0, -1));
  }, []);

  const current = useMemo(() => stack[stack.length - 1] ?? null, [stack]);

  return { current, push, pop };
}
